/**
 * 4.3.8 walkthrough slides.
 *
 * Each slide:
 *   {
 *     image:          public-path string (e.g. '/walkthroughs/4.3.8/foo.png'),
 *     title:          short heading,
 *     body:           one or two sentences describing the change,
 *     minRoleWeight?: integer — only users with role_weight >= this see the slide
 *                     (matches hasMinRole gating; omit for "visible to everyone")
 *     is_cloud_only?: boolean — true hides the slide on 4.0 campuses, for features
 *                     that only exist on the 5.0 cloud architecture. Omitted or
 *                     false means architecture-independent. Evaluated against the
 *                     campus config's `is_cloud` in collectSlides (index.js).
 *   }
 *
 * Drop walkthrough images under public/walkthroughs/{version}/.
 */
export default [
  {
    image: '/walkthroughs/4.3.8/slide1.png',
    title: 'Enhanced Alert Visibility',
    body: 'Active alerts used to live on the Alerts page only, with a count in the navigation as the one hint that something was happening. Now they show up where your teams are already working: resident, area, and device profiles display any active alert, and the Residents, Areas, and Devices tables mark the affected row so it stands out at a glance. Hover or click the bell icon on a marked row to see what is going on.',
    minRoleName: "All Administrators, Corporate",
    minRoleWeight: 10,
    is_cloud_only: false
  },{
    image: '/walkthroughs/4.3.8/slide2.png',
    title: 'Better Reporting Capability',
    body: 'Reports can now focus on the hours that matter, not just the days. Set a Time of Day alongside the date range to look at a single shift, including overnight windows such as 8 PM to 8 AM. The same setting saves on scheduled reports, so a report that arrives every week can cover only the hours your teams asked about.',
    minRoleName: "All Administrators, Corporate",
    minRoleWeight: 10,
    is_cloud_only: false
  }
];